import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Container, Row, Col, Form, Button, InputGroup } from 'react-bootstrap';
import $ from 'jquery';

const VerifyOTP = () => {
  const navigate = useNavigate();
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const DefaultAppId = process.env.REACT_APP_DEFAULT_APP_ID;
  const location = useLocation();
  const { email,whatsappNo, actionType, verificationMethod } = location.state || {};

  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');

  const handleOtpSubmit = async (e) => {
    e.preventDefault();

    // Basic OTP Validation: 6 digit numeric check
    if (!/^\d{6}$/.test(otp)) {
      setError('Please enter a valid 6-digit OTP');
      return;
    }

    let verificationMethod = email !== undefined ? 1 : 2;
    
    debugger;
    setError('');
    $.ajax({
      url: `${apiBaseUrl}/Auth/verify-otp`,
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify({
        whatsAppNo: whatsappNo,
        email:email,
        accountId: DefaultAppId,
        accountVerificationType: verificationMethod,
        otpNumber: otp
      }),
      success: function (response) {
        debugger;
        if (response.success && response.data) {
          if (actionType === 'forgotemail') {
            setError(`Your Email: ${response.data.email || 'Not found'}`);
          } else {
            navigate('/ChangePassword',{
            state: {
              email:response.data.email,
            }
          });
            
          }
        } else {
          setError(response.message || 'Invalid OTP. Please try again.');
        }
      },
      error: function () {
        setError('Invalid OTP. Please try again.');
      }
    });
  }
  
  
    const handleOtpChange = (e) => {
      const value = e.target.value;
      if (/^\d*$/.test(value)) {
        setOtp(value);
      }
    };

  const maskWhatsappNo = (number) => {
    if (!number) return '';
    const visibleDigits = number.slice(-4);
    const maskedPart = '*'.repeat(number.length - 4);
    return maskedPart + visibleDigits;
  };

  const maskEmail = (email) => {
    if (!email) return '';
    const [local, domain] = email.split('@');
    const maskedLocal = local[0] + '*'.repeat(Math.max(local.length - 1, 1));
    return `${maskedLocal}@${domain}`;
  };

  const getMaskedMessage = () => {
    if (verificationMethod === 'email') {
      return `Enter the passcode we have sent to your email address: ${maskEmail(email)}`;
    } else {
      return `Enter the passcode we have sent to your whatsapp ending with ${maskWhatsappNo(whatsappNo)}`;
    }
  };

  return (
    <div className="bg-light py-5">
      <Container className="bg-white rounded shadow p-4">
        <Row className="align-items-center">
          <Col md={6} className="text-center">
            <img
              src='/assets/images/login-illustration.png'
              alt="Login Illustration"
              className="img-fluid rounded mb-3"
              style={{ maxHeight: '300px' }}
            />
            <p className="text-muted fs-5">Let us help you grow..</p>
          </Col>

          <Col md={6}>
            <div className="p-3">
              <h2 className="fw-bold mb-2 d-flex align-items-center gap-2">
                Verify OTP
                <img src='/assets/images/logo.png' alt="Logo" width="50" />
              </h2>
              <h6>Recieved Passcode?</h6>
              <br/>
              <p>{getMaskedMessage()}</p>

              <Form onSubmit={handleOtpSubmit}>
                <Form.Group className="mb-3" controlId="Otp">
                  <Form.Label>
                    OTP <span style={{ color: 'red' }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={otp}
                    onChange={handleOtpChange}
                    maxLength="6"
                    required
                    onCopy={(e) => e.preventDefault()}
                    onPaste={(e) => e.preventDefault()}
                    onCut={(e) => e.preventDefault()}
                  />
                  {error && (
                    <div className="text-danger mt-1" style={{ fontSize: '0.9rem' }}>
                      {error}
                    </div>
                  )}
                </Form.Group>

                <Button
                  type="submit"
                  className="w-100 text-white fw-semibold"
                  style={{
                    backgroundColor: '#CC5500',
                    border: 'none',
                  }}
                >
                  Verify OTP
                </Button>
              </Form>

              <p className="mt-3 text-center">
                Didn’t get the OTP? <a href="#" className="text-primary">Resend</a>
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default VerifyOTP;
